import { render, staticRenderFns } from "./CanceledBooking.vue?vue&type=template&id=c98b1064"
import script from "./CanceledBooking.vue?vue&type=script&lang=js"
export * from "./CanceledBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports